// Code generated by backend/cmd/gen-bsd — DO NOT EDIT.
//
// Single source of truth for the residential Buyer's Stamp Duty schedule is
// backend/internal/constants/calc.go (BSDResidentialBands + BSDRatesVersion).
// A future IRAS rate change is a one-place edit in Go, then
// `cd backend && go generate ./...` regenerates this file for web and iOS.
// Do not hand-edit, and do not re-add a hand-copied band table (PROP-250).

export const BSD_RATES_VERSION = "2023-02-15";

// Progressive residential BSD bands as [cumulativeUpperBound, rate] pairs
// (Infinity = top band), matching the Go schedule exactly.
export const BSD_RES_BANDS: readonly [number, number][] = [
  [180000, 0.01],
  [360000, 0.02],
  [1000000, 0.03],
  [1500000, 0.04],
  [3000000, 0.05],
  [Infinity, 0.06],
];

// Compute Buyer's Stamp Duty on a residential purchase price by applying the
// progressive BSD_RES_BANDS schedule. e.g. estBsd(2_480_000) === 93_600.
export function estBsd(price: number): number {
  let bsd = 0;
  let remaining = price;
  let prev = 0;
  for (const [upper, rate] of BSD_RES_BANDS) {
    if (remaining <= 0) break;
    const chunk = Math.min(remaining, upper - prev);
    bsd += chunk * rate;
    remaining -= chunk;
    prev = upper;
  }
  return bsd;
}
